// extracted by mini-css-extract-plugin
module.exports = {"date_container":"AbsenceDateRange_date_container__2JWOT","modal_heading":"AbsenceDateRange_modal_heading__2RwgR","date":"AbsenceDateRange_date__1d2Vp"};